import { StyleRules } from '@material-ui/core/styles';
import { RadioClassKey } from '@material-ui/core/Radio';

import { core as theme } from '../styles/core';

export const MuiRadio: Partial<StyleRules<RadioClassKey>> = {
  root: {
    color: theme.palette.grey.A700,
    '&$checked$colorPrimary, &$checked$colorSecondary': {
      color: theme.palette.grey.A700,
    },
  },
  colorPrimary: {
    '&$checked': {
      '& .MuiSvgIcon-root:nth-child(2)': {
        color: theme.palette.primary.main,
      },
    },
  },
  colorSecondary: {
    '&$checked': {
      '& .MuiSvgIcon-root:nth-child(2)': {
        color: theme.palette.secondary.main,
      },
    },
  },
};
